import React, { useContext, useEffect, useState } from 'react';
import { AccountContext } from '../../../components/AccountContext';
import { NotificationContext } from '../../../components/GrowlNotifications';
import { defineMessages, useIntl } from 'react-intl';
import { Loading } from '../../../components/Loading';
import { growlErrors } from '../../../utils/NotificationUtil';
import { useQuery } from '@apollo/react-hooks';
import { Panel } from 'primereact/panel';
import NoSuperProfiles from './list/NoSuperProfiles';
import SuperProfilesListHeader from './list/SuperProfilesListHeader';
import SuperProfilesList from './list/SuperProfilesList';
import { SUPER__PROFILES_QUERY } from './services/super--profiles.service';
import DeleteSuperProfileConfirmationDialog from './list/DeleteSuperProfileConfirmationDialog';

const i18nMessages = defineMessages({
  superProfiles: {
    id: 'account.super-profiles',
    defaultMessage: 'SuperProfiles',
  },
});

const SuperProfiles = () => {
  const currentAccount = useContext(AccountContext);
  const growl = useContext(NotificationContext);
  const { formatMessage } = useIntl();

  const [filter, setFilter] = useState(null);
  const [superProfileToDelete, setSuperProfileToDelete] = useState(null);
  const [superProfiles, setSuperProfiles] = useState([]);

  const { loading, error, data } = useQuery(SUPER__PROFILES_QUERY, {
    variables: {
      accountId: currentAccount,
    },
    fetchPolicy: 'no-cache',
  });

  const { account } = data;

  useEffect(() => {
    if (account) {
      setSuperProfiles(account.superProfiles);
    }
    // eslint-disable-next-line
  }, [account]);

  if (loading) {
    return <Loading />;
  }

  if (error) {
    growlErrors(growl, error);
  }

  if (superProfiles.length === 0) {
    return <NoSuperProfiles />;
  }

  return (
    <div className="p-grid">
      <div className="p-col-12">
        <div className="brand-detailed-wrapper">
          <DeleteSuperProfileConfirmationDialog
            superProfileId={superProfileToDelete}
            hide={() => setSuperProfileToDelete(null)}
          />
          <Panel header={formatMessage(i18nMessages.superProfiles)}>
            <SuperProfilesListHeader filter={filter} setFilter={setFilter} />
            <SuperProfilesList
              superProfiles={superProfiles}
              filter={filter}
              setSuperProfileToDelete={setSuperProfileToDelete}
            />
          </Panel>
        </div>
      </div>
    </div>
  );
};

export default SuperProfiles;
